import { Layout, Grid, Flex, Typography, Button } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import { ReloadOutlined, WarningOutlined, SunOutlined, MoonOutlined } from "@ant-design/icons";
import AppSideMenu from "components/layout/AppSideMenu";
import ErrorBoundary from "components/ErrorBoundary";
import { useTheme } from "hooks/useTheme";

const { Title, Text } = Typography;

const pageFallback = (
  <Flex vertical align="center" justify="center" style={{ minHeight: '60vh', gap: 16 }}>
    <WarningOutlined style={{ fontSize: 48, color: '#faad14' }} />
    <Title level={3} style={{ margin: 0 }}>Something went wrong</Title>
    <Text type="secondary">An unexpected error occurred on this page.</Text>
    <Button type="primary" icon={<ReloadOutlined />} onClick={() => window.location.reload()}>
      Reload
    </Button>
  </Flex>
);

const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const location = useLocation();
  const { isDark, toggleTheme } = useTheme();

  const handleMenuClick = () => {
    if (!screens.md) {
      setCollapsed(true);
    }
  };

  return (
    <Layout>
      <Sider
        width={220}
        breakpoint="md"
        collapsed={collapsed}
        onCollapse={setCollapsed}
        zeroWidthTriggerStyle={{
          top: '12px'
        }}
      >
        <AppSideMenu collapsed={collapsed} onMenuClick={handleMenuClick} />
      </Sider>
      <Layout>
        <Header style={{ padding: '0 16px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <Button
            type="text"
            icon={isDark ? <MoonOutlined /> : <SunOutlined />}
            onClick={toggleTheme}
          />
        </Header>
        <Content
          style={{
            margin: screens.xs ? '8px' : screens.sm ? '12px' : '16px',
            minHeight: '100vh'
          }}
        >
          <ErrorBoundary key={location.pathname} fallback={pageFallback}>
            <Outlet />
          </ErrorBoundary>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
